import { getApp, getApps, initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

// Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBkUXP1PNvS9VcvCZjgR4cqEsZo4dZWcTM',
  authDomain: 'zamzam-e0859.firebaseapp.com',
  projectId: 'zamzam-e0859',
  storageBucket: 'zamzam-e0859.firebasestorage.app',
  messagingSenderId: '570666655779',
  appId: '1:570666655779:web:aafc4cf973c0282b879196',
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const messaging = async () => {
  const supported = await isSupported();
  return supported ? getMessaging(app) : null;
};

const fetchToken = async () => {
  try {
    const fcmMessaging = await messaging();
    if (fcmMessaging) {
      const token = await getToken(fcmMessaging, {
        vapidKey: process.env.NEXT_PUBLIC_FIREBASE_FCM_VAPID_KEY,
      });
      return token;
    }
    return null;
  } catch (err) {
    // console.error('An error occurred while fetching the token:', err);
    return null;
  }
};

export { app, messaging, fetchToken };
